import React from 'react';
import { Field } from 'formik';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import FieldMessage from '../field-message';

const Message = ({ name, id, helpText, errorMessageFormatter }) => (
  <Field name={name}>
    {({ field, form, meta }) => {
      const { touched, submitCount } = meta;
      const { status } = form;

      const error = meta.error || get(status, `errors.${name}`); // server-side error

      return (
        <FieldMessage
          touched={touched}
          error={errorMessageFormatter({ error, field, form, meta })}
          submitCount={submitCount}
          name={name}
          id={id}
          helpText={helpText}
        />
      );
    }}
  </Field>
);

Message.propTypes = {
  name: PropTypes.string,
  helpText: PropTypes.string,
  errorMessageFormatter: PropTypes.func,
  id: PropTypes.string,
};

Message.defaultProps = {
  errorMessageFormatter: ({ error }) =>
    error && typeof error === 'object'
      ? Object.values(error).join(', ')
      : error,
};

export default Message;
